// extracted by mini-css-extract-plugin
export default {"peopleCard":"PeopleCard_peopleCard__Jy34+","figure":"PeopleCard_figure__vMVjl","imgCaption":"PeopleCard_imgCaption__GBTfM","link":"PeopleCard_link__kPwsW"};